import React, {useEffect} from "react";
import CountUp from "react-countup";
import {Col, Row, Select, Spin, Statistic} from "antd";
import {
  CaretDownFilled,
  CreditCardOutlined,
  LoadingOutlined,
  PieChartOutlined,
  RiseOutlined,
  ShoppingCartOutlined
} from "@ant-design/icons"
import {Root, StatTitle, StyledCard} from "./styled";
import {useDashboardContext} from "contexts/DashboardProvider";

const Totals = () => {

  const {state, fetchTotal, updateState} = useDashboardContext()

  useEffect(() => {
    fetchTotal("total_sales")
  }, [state.branch_id, state.total_sales_date])

  useEffect(() => {
    fetchTotal("total_expenses")
  }, [state.branch_id, state.total_expenses_date])

  useEffect(() => {
    fetchTotal("total_pullouts")
  }, [state.branch_id, state.total_pullouts_date])

  useEffect(() => {
    fetchTotal("total_payments")
  }, [state.branch_id, state.total_payments_date])

  return (
     <Root>
       <Row gutter={[16, 16]}>
         <Col span={6} lg={6} md={12} sm={12} xs={24}>
           <CustomCard
             title={"Sales"}
             cardValue={state.total_sales}
             selectValue={state.total_sales_date}
             onSelectChange={(value) => updateState({ total_sales_date: value })}
             icon={<RiseOutlined className={"card-icon"} />}
             className={"bg-primary"}
             loading={state.is_loading_total_sales}
           />
         </Col>
         <Col span={6} lg={6} md={12} sm={12} xs={24}>
           <CustomCard
             title={"Expenses"}
             cardValue={state.total_expenses}
             selectValue={state.total_expenses_date}
             onSelectChange={(value) => updateState({ total_expenses_date: value })}
             icon={<PieChartOutlined className={"card-icon"} />}
             className={"bg-danger"}
             loading={state.is_loading_total_expenses}
           />
         </Col>
         <Col span={6} lg={6} md={12} sm={12} xs={24}>
           <CustomCard
             title={"Pullouts"}
             cardValue={state.total_pullouts}
             selectValue={state.total_pullouts_date}
             onSelectChange={(value) => updateState({ total_pullouts_date: value })}
             icon={<ShoppingCartOutlined className={"card-icon"} />}
             className={"bg-warning"}
             loading={state.is_loading_total_pullouts}
           />
         </Col>
         <Col span={6} lg={6} md={12} sm={12} xs={24}>
           <CustomCard
             title={"Payments"}
             cardValue={state.total_payments}
             selectValue={state.total_payments_date}
             onSelectChange={(value) => updateState({ total_payments_date: value })}
             icon={<CreditCardOutlined className={"card-icon"} />}
             className={"bg-success"}
             loading={state.is_loading_total_payments}
           />
         </Col>
       </Row>
    </Root>
  )
}

export const CustomCard = ({
  title,
  cardValue,
  selectValue,
  onSelectChange,
  icon,
  className,
  loading = false
}) => {
  const {state} = useDashboardContext()
  return (
    <StyledCard bordered={false} className={className}>
      <Statistic
        title={(
          <StatTitle>
            <div>{title}</div>
            <Select
              size={"small"}
              value={selectValue}
              onChange={onSelectChange}
              options={state.date_filters}
              suffixIcon={<CaretDownFilled />}
            />
          </StatTitle>
        )}
        value={cardValue}
        precision={2}
        formatter={() => loading
          ? <Spin indicator={<LoadingOutlined spin />} />
          : <CountUp end={cardValue} duration={2} decimals={2} />
        }
      />
      {icon}
    </StyledCard>
  )
}

export default Totals
